import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Rocket } from "lucide-react";
import { ProgereReleaseService } from "@/services/progereReleases";
import { PROGERE_MODULE } from "@/config/progereModule";

// ProgereVersionBadge — affiche la version actuelle du module (menu, À propos).
export function ProgereVersionBadge({ clickable = true, className = "" }) {
  const navigate = useNavigate();
  const [version, setVersion] = useState(null);

  useEffect(() => {
    ProgereReleaseService.current().then((d) => setVersion(d.version)).catch(() => {});
  }, []);

  if (!version) return null;
  const content = (
    <span className="progere-version-badge" data-testid="version-badge">
      <Rocket size={12} /> {PROGERE_MODULE.fullName} · <b>v{version}</b>
    </span>
  );
  if (!clickable) return <span className={className}>{content}</span>;
  return (
    <button onClick={() => navigate("/nouveautes")} className={`hover:opacity-80 transition-opacity ${className}`} data-testid="version-badge-btn">
      {content}
    </button>
  );
}
